import React from 'react';
import googleLogo from './google.png';
import './App.css';
import { Box, TextField, InputAdornment, Button, Checkbox, FormGroup, FormControlLabel, FormControl } from '@mui/material';

function App() {
  return (
    <>
      <div className='App'>
        <div className='table'>
          <div style={{textAlign: "left", width: "390px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around"}}>
            <img src={googleLogo} style={{width: "75px", height: "24px"}} />
            <h2 style={{fontWeight: 500}}>
              Создайте аккаунт Google
            </h2>
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
              <TextField 
                id="outlined-basic" 
                label="Имя" 
                variant="outlined" 
                style={{width: "48%", marginRight: "2%"}}
              />
              <TextField 
                id="outlined-basic" 
                label="Фамилия" 
                variant="outlined" 
                style={{width: "48%", marginLeft: "2%"}}
              />
            </Box>
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
              <TextField
                id="outlined-basic" 
                label="Имя пользователя" 
                variant="outlined" 
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{color: "#202124", direction: "ltr"}}>
                        @gmail.com
                      </span>
                    </InputAdornment>)
                }}
                helperText="Можно использовать буквы латинского алфавита, цифры и точки."
              />
            </Box>
            <div>
              <Button variant="text" style={{fontWeight: 600, textTransform: "none"}}>Использовать текущий адрес электронной почты</Button>
            </div>
            <Box
              component="form"
              noValidate
              autoComplete="off"
            >
              <TextField 
                id="outlined-basic" 
                label="Пароль" 
                variant="outlined" 
                style={{width: "48%", marginRight: "2%"}}
              />
              <TextField 
                id="outlined-basic" 
                label="Подтвердить" 
                variant="outlined" 
                style={{width: "48%", marginLeft: "2%"}}
              />
            </Box>
            <div style={{
              color: "rgba(0, 0, 0, 0.6)",
              fontWeight: 400,
              fontSize: "0.75rem",
              lineHeight: 1.66,
              letterSpacing: "0.03333em",
              textAlign: "left",
              margiTop: "3px",
              marginRight: "14px",
              marginBottom: 0,
              marginLeft: "14px"
            }}>
              Пароль должен содержать не менее восьми знаков, включать буквы, цифры и специальные символы
            </div>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value="end"
                  control={<Checkbox />}
                  label="Показать пароль"
                  labelPlacement="end"
                />
              </FormGroup>
            </FormControl>
            <div style={{display: "flex", alignItem: "center", justifyContent: "space-between"}}>
              <Button variant="text" style={{fontWeight: 600, textTransform: "none"}}>Войти</Button>
              <Button variant="contained" style={{fontWeight: 500, textTransform: "none", width: "94px"}}>Далее</Button>
            </div>
          </div>
          <div className='right'>
            <img src="https://ssl.gstatic.com/accounts/signup/glif/account.svg" style={{width: "244px", height: "244px"}}/>
            <div style={{color: "#202124", textAlign: "center", lineHeight: 1.4286, fontSize: "14px"}}>Один аккаунт – для всех сервисов Google</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
